const getWindowDimensions = () => ({
    x: window.innerWidth,
    y: window.innerHeight
});
/**
 * Check view port width
 * @ignore
 * @return {Coord}
 */
export default function useWindowDimensions() {
    const windowDimensions = {
        x: 0,
        y: 0
    };
    const setWindowDimensions = () => {
        const { x, y } = getWindowDimensions();
        windowDimensions.x = x;
        windowDimensions.y = y;
    };
    setWindowDimensions();
    window.addEventListener('resize', setWindowDimensions, false);
    return windowDimensions;
}
